import React, { useState } from 'react'
import { SimpleForm, Create, useNotify, useRedirect } from 'react-admin'

import { Grid, Button, makeStyles, Paper, Typography } from '@material-ui/core'
import { QuestionForm } from './containers'

// import { Tooltip } from 'component'

const useStyles = makeStyles({
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  buttonContainer: {
    marginTop: 40,
  },
  paper: {
    width: 'auto',
    maxWidth: '100%',
    padding: 16,
  },
})

export const CreateForm = (props: any) => {
  const redirect = useRedirect()
  const notify = useNotify()
  const classes = useStyles()
  const {
    setFormData,
    formTitle = '',
    shouldRedirect = true,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
    toolbar = <></>,
    aside = <></>,
    ...rest
  } = props

  const [questions, setQuestions] = useState([1])

  const addQuestion = (_questions: any) => {
    const newCollection = [..._questions]
    newCollection.push(_questions.length + 1)
    setQuestions(newCollection)
  }

  const onSuccess = () => {
    notify('post_successfully')
    if (shouldRedirect) redirect(props.basePath)
    onSubmitSuccess()
  }

  const onFailure = (error: any) => {
    onSubmitFailure(error)
    notify('post_failed', 'warning')
  }

  return (
    <Create aside={aside} {...rest} onSuccess={onSuccess} onFailure={onFailure}>
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        toolbar={toolbar}
      >
        <Paper className={classes.paper}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography variant="h5" color="textSecondary" gutterBottom>
              {formTitle}
            </Typography>
            <hr />
            <Typography
              variant="subtitle1"
              color="textPrimary"
            >{`Perguntas e Respostas `}</Typography>
            <Typography variant="body2" color="textSecondary">
              {`Para cada Pergunta, lembre-se de inserir uma Resposta correta com sua justificativa.`}
            </Typography>
          </Grid>

          {questions.map((question, index) => {
            return <QuestionForm questionIndex={index} />
          })}

          <Grid item className={classes.buttonContainer}>
            <hr />
            <Button
              variant="contained"
              color="primary"
              onClick={() => addQuestion(questions)}
            >
              Criar Nova Pergunta
            </Button>
          </Grid>
        </Paper>
      </SimpleForm>
    </Create>
  )
}
